import './TicketDetailDialog.less';

import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { fromJS } from 'immutable';
import i18n from '@i18n';

import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import TicketHeader from './TicketHeader';
import { SuspendedTicketDetail } from '@/mytickets/detail/views/SuspendedTicketDetail';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import TicketIcon from '@/icons/TicketIcon';
import { ticketDetail$ } from '@/mytickets/detail/subs';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import { loadCreateAnalysisBetIds } from '@/betbook/handlers';
import { clearCreateAnalysisBetIds } from 'nike-ui/src/components/betbook/handlers';
import { accountCustomerId$ } from '@/account/subs';
import { BetbookContextProvider } from 'nike-ui/src/common/BetbookContext';

function TicketDetailDialog({ hash, isAnalysis, betbookContext }) {
    const { subscribe } = useReframe();
    const ticket = subscribe(ticketDetail$(hash)) || {};
    const { customerId, source, status, ticketId } = ticket;
    const currentCustomerId = subscribe(accountCustomerId$);
    const currentUserTicket = customerId && currentCustomerId && customerId === currentCustomerId;
    const saved = source === 'Saved';
    const paidOut = status === 'PaidOut';

    useEffect(() => {
        if (!paidOut && !saved && currentUserTicket) {
            dispatch(loadCreateAnalysisBetIds(ticketId));
            return () => dispatch(clearCreateAnalysisBetIds);
        }
    }, [currentUserTicket, paidOut, saved, ticketId]);

    useEffect(() => {
        dispatch(['ticketus/detail/fetch', [hash]]);
        dispatch(['scoreboard/start']);
        return () => dispatch(['scoreboard/stop']);
    }, [hash]);

    const Dialog = (
        <Docked hideCloseButton>
            <DialogTitle className="ticket-detail-dialog-title">
                <TicketHeader ticket={ticket} headerInDialog />
            </DialogTitle>
            <DialogBody className="ticket-detail-dialog-body">
                {ticket.error ? (
                    <EmptyState
                        className="ticket-detail-dialog-empty"
                        text={i18n('Detail tiketu sa nepodarilo nacitat')}
                        stateIcon={<TicketIcon />}
                    />
                ) : (
                    <SuspendedTicketDetail
                        ticket={fromJS(ticket)}
                        isActive
                        stickyHeader={false}
                        renderWithTicketHeader={false}
                    />
                )}
            </DialogBody>
        </Docked>
    );

    return (
        <BetLocationContext.Provider
            value={{
                betLocationSection: isAnalysis ? betLocation.COMMUNITY_ANALYSIS_DETAIL : betLocation.BETBOOK_CHAT_TICKET
            }}
        >
            {betbookContext ? (
                <BetbookContextProvider
                    betbookPostId={betbookContext.betbookPostId}
                    betbookPostType={betbookContext.betbookPostType}
                    betbookPostAuthor={betbookContext.betbookPostAuthor}
                    betbookBetId={betbookContext.betbookBetId}
                    betbookBetSelectionCode={betbookContext.betbookBetSelectionCode}
                >
                    {Dialog}
                </BetbookContextProvider>
            ) : (
                Dialog
            )}
        </BetLocationContext.Provider>
    );
}

export default TicketDetailDialog;
